import { render } from "./UiTestView.vue?vue&type=template&id=c2ee1146"
import script from "./UiTestView.vue?vue&type=script&lang=js"
export * from "./UiTestView.vue?vue&type=script&lang=js"

import "./UiTestView.vue?vue&type=style&index=0&id=c2ee1146&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__